import React, { useState } from 'react'
import {
  Button,
  Form, FormGroup,
  Input, Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'

function ResetPw({
  data,
  selectedPortalUsers,
  onSubmit,
  onClose,
  Lang
}) {

  const [password, setPassword] = useState('')
  const [confirmPW, setConfirmPW] = useState('')
  const [viewPW, setViewPW] = useState(false)
  const [viewConfirmPW, setConfirmViewPW] = useState(false)
  
  return (
    <>
      <ModalHeader toggle={ () => onClose()}>
        { Lang[ 'RESET_PW' ][ data.languageReducer.userSettings.admin_panel_language ] }
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label style={{ display: 'flex', alignItems: 'center' }}>
              { Lang[ 'NEW_PW' ][ data.languageReducer.userSettings.admin_panel_language ]}
              <div style={{ cursor: 'pointer'}} className='ml-2' onClick={() => setViewPW(!viewPW)}>
              {
                viewPW && (
                  <AiFillEye fontSize={20}/>
                )
              }
              {
                !viewPW && (
                  <AiFillEyeInvisible fontSize={20}/>
                )
              }
              </div>
            </Label>
            <Input
              value={ password }
              type={ viewPW ? 'text': 'password' }
              onChange={ e => setPassword( e.target.value )}
            />
          </FormGroup>
          <FormGroup>
            <Label style={{ display: 'flex', alignItems: 'center' }}>
              { Lang[ 'CONFIRM_PASSWORD' ][ data.languageReducer.userSettings.admin_panel_language ]}
              <div style={{ cursor: 'pointer'}} className='ml-2' onClick={() => setConfirmViewPW(!viewConfirmPW)}>
              {
                viewConfirmPW && (
                  <AiFillEye fontSize={20}/>
                )
              }
              {
                !viewConfirmPW && (
                  <AiFillEyeInvisible fontSize={20}/>
                )
              }
              </div>
            </Label>
            <Input
              value={ confirmPW }
              type={ viewConfirmPW ? 'text': 'password' }
              onChange={ e => setConfirmPW( e.target.value )}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color={ 'primary' }
          onClick={() => onSubmit(selectedPortalUsers.id, password, () => onClose())}
        >
          { Lang[ 'SUBMIT' ][ data.languageReducer.userSettings.admin_panel_language ]}
        </Button>
      </ModalFooter>
    </>
  )
}

export default ResetPw